const validate = (value, { bik } = {}) => {
  let result = false
  if (!bik || !bik.length) {
    return false
  }
  if (typeof value === 'number') {
    value = value.toString()
  } else if (typeof value !== 'string') {
    value = ''
  }
  if (!!value.length && /[0-9]/.test(value) && value.length === 20) {
    const bikRs = bik.toString().slice(-3) + value
    let checksum = 0
    const coefficients = [7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1]
    for (const i in coefficients) {
      checksum += coefficients[i] * (bikRs[i] % 10)
    }
    if (checksum % 10 === 0) {
      result = true
    }
  }

  return result
}

export default {
  validate,
  params: ['bik']
}
